'use strict';
var AGGREGATOR_MAP = {
    count: 'count',
    average: 'avg',
    minimum: 'min',
    maximum: 'max',
    sum: 'sum'
};
var AGGREGATORS = Object.values(AGGREGATOR_MAP);
var LEGACY_TIMESTAMP_MAP = {
    gmtCreate: 'createdAt',
    gmtModified: 'updatedAt',
    gmtDeleted: 'deletedAt',
};
var LEGACY_TIMESTAMP_COLUMN_MAP = {
    created_at: 'gmt_create',
    updated_at: 'gmt_modified',
    deleted_at: 'gmt_deleted',
};
var TIMESTAMP_ATTRIBUTE_NAMES = [
    'createdAt', 'updatedAt', 'deletedAt',
    'gmtCreate', 'gmtModified', 'gmtDeleted',
    'created_at', 'updated_at', 'deleted_at',
    'gmt_create', 'gmt_modified', 'gmt_deleted',
];
var TIMESTAMP_NAMES = ['createdAt', 'updatedAt', 'deletedAt'];
var ASSOCIATE_METADATA_MAP = {
    hasMany: Symbol('hasMany'),
    hasOne: Symbol('hasOne'),
    belongsTo: Symbol('belongsTo'),
};
var IS_LEORIC_BONE = Symbol('leoric#bone');
module.exports = {
    AGGREGATOR_MAP: AGGREGATOR_MAP,
    LEGACY_TIMESTAMP_MAP: LEGACY_TIMESTAMP_MAP,
    TIMESTAMP_NAMES: TIMESTAMP_NAMES,
    LEGACY_TIMESTAMP_COLUMN_MAP: LEGACY_TIMESTAMP_COLUMN_MAP,
    ASSOCIATE_METADATA_MAP: ASSOCIATE_METADATA_MAP,
    TIMESTAMP_ATTRIBUTE_NAMES: TIMESTAMP_ATTRIBUTE_NAMES,
    AGGREGATORS: AGGREGATORS,
    IS_LEORIC_BONE: IS_LEORIC_BONE,
};
//# sourceMappingURL=constants.js.map